import { useMutation } from '@tanstack/react-query';
import { AuthOutput, LoginInput, MutationLoginArgs } from '../gql/graphql';
import { graphqlFetch } from '@/utils/graphqlFetch';
import { LOGIN_MUTATION } from '../mutations';

export const useLogin = () => {
  return useMutation<AuthOutput, Error, LoginInput>({
    mutationKey: ['login'],
    mutationFn: async (input) => {
      const data = await graphqlFetch<{ login: AuthOutput }, MutationLoginArgs>(
        LOGIN_MUTATION,
        { input },
      );
      return data.login;
    },
  });
};
